import LegalLayout, { Section } from "./LegalLayout";

export default function PolitykaPrywatnosci() {
  return (
    <LegalLayout
      title="Polityka prywatności"
      subtitle="Jak przetwarzamy Twoje dane osobowe w serwisie Progres."
      updatedAt="2026-02-08"
      testid="page-polityka"
    >
      <Section heading="§1. Administrator danych">
        <p>
          Administratorem danych osobowych jest <strong>FeGrro Dominik Grzenia</strong>,
          ul. Na Równiku 1, 83-314 Sławki, NIP: 5892037971 (dalej: „Administrator").
        </p>
        <p>Kontakt w sprawach ochrony danych: <strong>kontakt@progres.pl</strong>.</p>
      </Section>

      <Section heading="§2. Podstawy prawne przetwarzania">
        <p>Dane osobowe przetwarzamy na następujących podstawach:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>
            <strong>Art. 6 ust. 1 lit. b RODO</strong> — wykonanie umowy o świadczenie usług
            (utrzymanie konta, dostęp do funkcji Serwisu).
          </li>
          <li>
            <strong>Art. 6 ust. 1 lit. c RODO</strong> — realizacja obowiązków prawnych
            (m.in. rozliczenia księgowe, obsługa reklamacji).
          </li>
          <li>
            <strong>Art. 6 ust. 1 lit. f RODO</strong> — prawnie uzasadniony interes
            Administratora (bezpieczeństwo Serwisu, dochodzenie i obrona roszczeń).
          </li>
        </ul>
      </Section>

      <Section heading="§3. Zakres i cel przetwarzania">
        <p>Przetwarzamy następujące kategorie danych:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>
            <strong>Dane rejestracyjne</strong>: adres e-mail, imię (opcjonalnie), hash hasła.
          </li>
          <li>
            <strong>Dane operacyjne</strong>: nawyki, wpisy treningowe, pomiary ciała, cele,
            zadania — wprowadzone przez Ciebie w Serwisie.
          </li>
          <li>
            <strong>Dane techniczne</strong>: adres IP (w logach serwera), typ przeglądarki,
            zdarzenia nawigacyjne w aplikacji (dla funkcji Smart-open).
          </li>
          <li>
            <strong>Dane rozliczeniowe</strong>: numer transakcji, status płatności, kwota, plan
            subskrypcji. Numery kart płatniczych, kody BLIK ani inne dane wrażliwe nie są
            przechowywane w Serwisie — są przetwarzane wyłącznie przez operatora Przelewy24.
          </li>
        </ul>
      </Section>

      <Section heading="§4. Okres przechowywania">
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Dane konta i dane operacyjne — przez okres aktywnego konta.</li>
          <li>
            Po usunięciu konta — dane są nieodwracalnie usuwane w ciągu <strong>30 dni</strong>,
            z wyjątkiem danych wymaganych prawem.
          </li>
          <li>Dane rozliczeniowe — przez 5 lat od końca roku obrachunkowego (obowiązek ustawowy).</li>
          <li>Logi techniczne — do 90 dni.</li>
        </ul>
      </Section>

      <Section heading="§5. Odbiorcy danych">
        <p>Dane mogą być przekazywane następującym podmiotom przetwarzającym (procesorom):</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>
            <strong>Resend Inc.</strong> — obsługa wysyłki wiadomości e-mail (weryfikacja konta,
            powiadomienia).
          </li>
          <li>
            <strong>PayPro S.A. (Przelewy24)</strong> — obsługa płatności online.
          </li>
          <li>
            <strong>Dostawca infrastruktury chmurowej</strong> — hosting aplikacji i baz danych.
          </li>
        </ul>
        <p>
          Nie przekazujemy danych do państw trzecich poza EOG bez zapewnienia odpowiednich
          zabezpieczeń (SCC — standardowe klauzule umowne).
        </p>
      </Section>

      <Section heading="§6. Prawa użytkownika">
        <p>Zgodnie z RODO przysługuje Ci prawo do:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>dostępu do swoich danych i uzyskania kopii,</li>
          <li>sprostowania (poprawienia) danych,</li>
          <li>usunięcia danych („prawo do bycia zapomnianym"),</li>
          <li>ograniczenia przetwarzania,</li>
          <li>przenoszenia danych (eksport JSON / CSV na żądanie),</li>
          <li>wniesienia sprzeciwu wobec przetwarzania opartego na art. 6 ust. 1 lit. f,</li>
          <li>
            wniesienia skargi do organu nadzorczego —{" "}
            <strong>Prezes Urzędu Ochrony Danych Osobowych</strong>, ul. Stawki 2, 00-193 Warszawa.
          </li>
        </ul>
        <p>
          Prawa realizujemy w terminie 30 dni od otrzymania żądania na adres{" "}
          <strong>kontakt@progres.pl</strong>.
        </p>
      </Section>

      <Section heading="§7. Pliki cookies i localStorage">
        <p>
          Serwis wykorzystuje pliki cookies oraz pamięć przeglądarki (localStorage) wyłącznie do
          utrzymania sesji zalogowanego użytkownika i podstawowej funkcjonalności aplikacji.
        </p>
        <p>Nie używamy cookies marketingowych ani trackingowych.</p>
        <p>
          W dowolnej chwili możesz usunąć pliki cookies z poziomu ustawień swojej przeglądarki.
          Usunięcie cookies sesji spowoduje wylogowanie z Serwisu.
        </p>
      </Section>

      <Section heading="§8. Bezpieczeństwo">
        <p>
          Dane są szyfrowane w transporcie (TLS 1.2+), hasła są hashowane funkcją bcrypt.
          Regularnie tworzone są kopie zapasowe. Dostęp do produkcyjnej bazy danych ma jedynie
          Administrator.
        </p>
      </Section>
    </LegalLayout>
  );
}
